/**
 * Commands shown on the token page (issue #100).
 *
 * Each command exists in two renderings built from the same template: a
 * masked one for the screen, and the full one for the clipboard. The token is
 * a secret, so the masked rendering never contains any part of it, not even
 * its length.
 *
 * Kept as pure string builders (no JSX) so they can be unit tested without a
 * DOM - this project's vitest config runs in the "node" environment.
 */

/** Binary name of the agent, as printed by `opcua-relay-agent --help` (agent/src/_main.ts). */
export const AGENT_COMMAND = "opcua-relay-agent";

/** Fixed-length mask: does not leak the length of the token. */
export const TOKEN_MASK = "•".repeat(24);

/** Command that enrols the agent with the token (agent/src/command/config). */
export function enrolCommand(token: string): string {
    return `${AGENT_COMMAND} config ${token}`;
}

/** Same command with `-f`: re-enrol an agent that already holds a token. */
export function reEnrolCommand(token: string): string {
    return `${AGENT_COMMAND} config ${token} -f`;
}

/** Content of the agent's `config.json` when the token is written by hand. */
export function configFileSnippet(token: string): string {
    return `{\n    "token": "${token}"\n}`;
}

/** Shows `masked` or `full` depending on the reveal state; the clipboard always gets the full value. */
export function displayedText(build: (token: string) => string, token: string, revealed: boolean): string {
    return build(revealed ? token : TOKEN_MASK);
}
